const downloadError = (rowsWithErrors) => {
    if (!rowsWithErrors.length) return;
    // console.log('DownloadError');

    const headers = [
        "Offer Name", "Item Code", "Percentage Type", "Value",
        "Start Date", "End Date", "Min Qty", "Max Qty", "Free Qty",
        "Branches", "Error Type", "Message"
    ];

    const csvContent = [
        headers.join(","), // CSV header
        ...rowsWithErrors.map(row => {
            const data = row.data || {};

            return [
                data["Offer Name"] || "",
                data["Item Code"] || "",
                data["Percentage Type"] || "",
                data["Value"] || "",
                data["Start Date"] || "",
                data["End Date"] || "",
                data["Min Qty"] || "",
                data["Max Qty"] || "",
                data["Free Qty"] || "",
                Array.isArray(data["Branches"]) 
                    ? data["Branches"].join(";") 
                    : data["Branches"] || "0",
                row.errorType,
                JSON.stringify(row.rowMessage || row.existingOfferMsg || "")
            ].join(",");
        })
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", "sync_errors.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

export default downloadError;
